var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('question-layout',{attrs:{"id":"which-club"}},[_c('jersey-question',{staticClass:"question",attrs:{"text":_vm.question}}),_c('jersey-dropdown',{attrs:{"modelName":"club","options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }